import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { nuxtI18nHead } from './head-meta';
import { Constants, nuxtOptions, options } from './options';
import { createLocaleFromRouteGetter, getLocaleCookie, getLocaleDomain, getLocalesRegex, matchBrowserLocale, parseAcceptLanguage, setLocaleCookie } from './utils-common';
import { loadLanguageAsync, resolveBaseUrl, registerStore, mergeAdditionalMessages } from './plugin.utils'; // @ts-ignore

import { joinURL } from '~i18n-ufo'; // @ts-ignore

import { klona } from '~i18n-klona';
Vue.use(VueI18n);
/** @type {import('@nuxt/types').Plugin} */

export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(context) {
    var app, route, store, req, res, redirect, lazy, injectInNuxtState, devalue, _options$detectBrowse, alwaysRedirect, fallbackLocale, redirectOn, useCookie, cookieKey, cookieDomain, cookieSecure, cookieCrossOrigin, getLocaleFromRoute, loadAndSetLocale, onNavigate, finalizePendingLocaleChange, waitForPendingLocaleChange, getBrowserLocale, doDetectBrowserLanguage, extendVueI18nInstance, vueI18nOptions, _iterator, _step, _step$value, index, locale, domain, optionsLocale, resolveBaseUrlOptions, finalLocale, domainLocale, routeLocale, _yield$onNavigate, _yield$onNavigate2, _, redirectTo;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            app = context.app, route = context.route, store = context.store, req = context.req, res = context.res, redirect = context.redirect;

            if (options.vuex && store) {
              registerStore(store, options.vuex, options.localeCodes);
            }

            lazy = options.lazy;
            injectInNuxtState = lazy && (lazy === true || lazy.skipNuxtState !== true);

            if (!(process.server && injectInNuxtState)) {
              _context5.next = 9;
              break;
            }

            _context5.next = 7;
            return import('devalue');

          case 7:
            devalue = _context5.sent.default;
            context.beforeNuxtRender(function (_ref2) {
              var nuxtState = _ref2.nuxtState;

              /** @type {Record<string, import('vue-i18n').LocaleMessageObject>} */
              var langs = {};
              var _app$i18n = app.i18n,
                  fallbackLocale = _app$i18n.fallbackLocale,
                  locale = _app$i18n.locale;

              if (locale && locale !== fallbackLocale) {
                // @ts-ignore Using internal API to avoid unnecessary cloning.
                var messages = app.i18n._getMessages()[locale];

                if (messages) {
                  try {
                    devalue(messages);
                    langs[locale] = messages;
                  } catch (_unused) {// Ignore - client-side will load the chunk asynchronously.
                  }
                }
              }

              nuxtState.__i18n = {
                langs: langs
              };
            });

          case 9:
            _options$detectBrowse =
            /** @type {Required<import('../../types').DetectBrowserLanguageOptions>} */
            options.detectBrowserLanguage, alwaysRedirect = _options$detectBrowse.alwaysRedirect, fallbackLocale = _options$detectBrowse.fallbackLocale, redirectOn = _options$detectBrowse.redirectOn, useCookie = _options$detectBrowse.useCookie, cookieKey = _options$detectBrowse.cookieKey, cookieDomain = _options$detectBrowse.cookieDomain, cookieSecure = _options$detectBrowse.cookieSecure, cookieCrossOrigin = _options$detectBrowse.cookieCrossOrigin;
            getLocaleFromRoute = createLocaleFromRouteGetter(options.localeCodes, {
              routesNameSeparator: options.routesNameSeparator,
              defaultLocaleRouteNameSuffix: options.defaultLocaleRouteNameSuffix
            });
            /**
             * @param {string | undefined} newLocale
             * @param {{ initialSetup?: boolean }} [options=false]
             */

            loadAndSetLocale = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newLocale) {
                var _ref4,
                    _ref4$initialSetup,
                    initialSetup,
                    oldLocale,
                    localeOverride,
                    i18nFallbackLocale,
                    localesToLoadPromises,
                    newLocaleProperties,
                    _i,
                    _Object$keys,
                    key,
                    _i2,
                    _Object$entries,
                    _Object$entries$_i,
                    _key,
                    value,
                    route,
                    redirectPath,
                    isStaticGenerate,
                    routePath,
                    _args = arguments;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _ref4 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref4$initialSetup = _ref4.initialSetup, initialSetup = _ref4$initialSetup === void 0 ? false : _ref4$initialSetup;

                        if (newLocale) {
                          _context.next = 3;
                          break;
                        }

                        return _context.abrupt("return");

                      case 3:
                        if (!(!initialSetup && app.i18n.differentDomains)) {
                          _context.next = 5;
                          break;
                        }

                        return _context.abrupt("return");

                      case 5:
                        oldLocale = app.i18n.locale;

                        if (!(newLocale === oldLocale)) {
                          _context.next = 8;
                          break;
                        }

                        return _context.abrupt("return");

                      case 8:
                        localeOverride = app.i18n.onBeforeLanguageSwitch(oldLocale, newLocale, initialSetup, context);

                        if (!(localeOverride && app.i18n.localeCodes.includes(localeOverride))) {
                          _context.next = 13;
                          break;
                        }

                        if (!(localeOverride === oldLocale)) {
                          _context.next = 12;
                          break;
                        }

                        return _context.abrupt("return");

                      case 12:
                        newLocale = localeOverride;

                      case 13:
                        if (useCookie) {
                          app.i18n.setLocaleCookie(newLocale);
                        }

                        if (!options.langDir) {
                          _context.next = 30;
                          break;
                        }

                        i18nFallbackLocale = app.i18n.fallbackLocale;

                        if (!options.lazy) {
                          _context.next = 26;
                          break;
                        }

                        if (!i18nFallbackLocale) {
                          _context.next = 22;
                          break;
                        }

                        /** @type {Promise<void>[]} */
                        localesToLoadPromises = [];

                        if (Array.isArray(i18nFallbackLocale)) {
                          localesToLoadPromises = i18nFallbackLocale.map(function (fbLocale) {
                            return loadLanguageAsync(context, fbLocale);
                          });
                        } else if (_typeof(i18nFallbackLocale) === 'object') {
                          if (i18nFallbackLocale[newLocale]) {
                            localesToLoadPromises = localesToLoadPromises.concat(i18nFallbackLocale[newLocale].map(function (fbLocale) {
                              return loadLanguageAsync(context, fbLocale);
                            }));
                          }

                          if (i18nFallbackLocale.default) {
                            localesToLoadPromises = localesToLoadPromises.concat(i18nFallbackLocale.default.map(function (fbLocale) {
                              return loadLanguageAsync(context, fbLocale);
                            }));
                          }
                        } else if (newLocale !== i18nFallbackLocale) {
                          localesToLoadPromises.push(loadLanguageAsync(context, i18nFallbackLocale));
                        }

                        _context.next = 22;
                        return Promise.all(localesToLoadPromises);

                      case 22:
                        _context.next = 24;
                        return loadLanguageAsync(context, newLocale);

                      case 24:
                        _context.next = 28;
                        break;

                      case 26:
                        _context.next = 28;
                        return Promise.all(options.localeCodes.map(function (locale) {
                          return loadLanguageAsync(context, locale);
                        }));

                      case 28:
                        _context.next = 31;
                        break;

                      case 30:
                        mergeAdditionalMessages(app.i18n, options.additionalMessages, options.localeCodes);

                      case 31:
                        app.i18n.locale = newLocale;
                        /** @type {import('../../types').LocaleObject} */

                        newLocaleProperties = options.normalizedLocales.find(function (l) {
                          return l.code === newLocale;
                        }) || {
                          code: newLocale
                        }; // In case certain locale has more properties than another, reset all the properties.

                        for (_i = 0, _Object$keys = Object.keys(app.i18n.localeProperties); _i < _Object$keys.length; _i++) {
                          key = _Object$keys[_i];
                          app.i18n.localeProperties[key] = undefined;
                        } // Copy properties of the new locale


                        for (_i2 = 0, _Object$entries = Object.entries(newLocaleProperties); _i2 < _Object$entries.length; _i2++) {
                          _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2), _key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                          Vue.set(app.i18n.localeProperties, _key, klona(value));
                        } // Must retrieve from context as it might have changed since plugin initialization.


                        route = context.route;
                        redirectPath = '';
                        isStaticGenerate = process.static && process.server; // Decide whether we should redirect to a different route.

                        if (!isStaticGenerate && !app.i18n.differentDomains && options.strategy !== Constants.STRATEGIES.NO_PREFIX && ( // Skip if already on the new locale unless the strategy is "prefix_and_default" and this is the default
                        // locale, in which case we might still redirect as we prefer unprefixed route in this case.
                        getLocaleFromRoute(route) !== newLocale || options.strategy === Constants.STRATEGIES.PREFIX_AND_DEFAULT && newLocale === options.defaultLocale)) {
                          // The current route could be 404 in which case attempt to find matching route using the full path since
                          // "switchLocalePath" can only find routes if the current route exists.
                          routePath = app.switchLocalePath(newLocale) || app.localePath(route.fullPath, newLocale);

                          if (routePath && routePath !== route.fullPath && !routePath.startsWith('//')) {
                            redirectPath = routePath;
                          }
                        }

                        if (initialSetup) {
                          // Redirect will be delayed until middleware runs as redirecting from plugin does not
                          // work in SPA (https://github.com/nuxt/nuxt.js/issues/4491).
                          app.i18n.__redirect = redirectPath;
                        } else {
                          app.i18n.onLanguageSwitched(oldLocale, newLocale);

                          if (redirectPath) {
                            redirect(redirectPath);
                          }
                        }

                      case 40:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function loadAndSetLocale(_x2) {
                return _ref3.apply(this, arguments);
              };
            }();
            /**
             * Called by middleware on navigation (also on the initial one).
             *
             * @type {import('../../types/internal').onNavigateInternal}
             */


            onNavigate = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(route) {
                var statusCode, path, storedRedirect, resolveBaseUrlOptions, finalLocale;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!(route.path === '/' && options.rootRedirect)) {
                          _context2.next = 5;
                          break;
                        }

                        statusCode = 302;
                        path = options.rootRedirect;

                        if (typeof options.rootRedirect !== 'string') {
                          statusCode = options.rootRedirect.statusCode;
                          path = options.rootRedirect.path;
                        }

                        return _context2.abrupt("return", [statusCode, "/".concat(path),
                        /* preserve query */
                        true]);

                      case 5:
                        storedRedirect = app.i18n.__redirect;

                        if (!storedRedirect) {
                          _context2.next = 9;
                          break;
                        }

                        app.i18n.__redirect = null;
                        return _context2.abrupt("return", [302, storedRedirect]);

                      case 9:
                        resolveBaseUrlOptions = {
                          differentDomains: options.differentDomains,
                          normalizedLocales: options.normalizedLocales
                        };
                        app.i18n.__baseUrl = resolveBaseUrl(options.baseUrl, context, app.i18n.locale, resolveBaseUrlOptions);
                        finalLocale = options.detectBrowserLanguage && doDetectBrowserLanguage(route) || !options.differentDomains && getLocaleFromRoute(route) || app.i18n.locale || app.i18n.defaultLocale || '';

                        if (!options.skipSettingLocaleOnNavigate) {
                          _context2.next = 17;
                          break;
                        }

                        app.i18n.__pendingLocale = finalLocale;
                        app.i18n.__pendingLocalePromise = new Promise(function (resolve) {
                          app.i18n.__resolvePendingLocalePromise = resolve;
                        });
                        _context2.next = 19;
                        break;

                      case 17:
                        _context2.next = 19;
                        return app.i18n.setLocale(finalLocale);

                      case 19:
                        return _context2.abrupt("return", [null, null]);

                      case 20:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function onNavigate(_x3) {
                return _ref5.apply(this, arguments);
              };
            }();

            finalizePendingLocaleChange = /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        if (app.i18n.__pendingLocale) {
                          _context3.next = 2;
                          break;
                        }

                        return _context3.abrupt("return");

                      case 2:
                        _context3.next = 4;
                        return app.i18n.setLocale(app.i18n.__pendingLocale);

                      case 4:
                        app.i18n.__resolvePendingLocalePromise('');

                        app.i18n.__pendingLocale = null;

                      case 6:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function finalizePendingLocaleChange() {
                return _ref6.apply(this, arguments);
              };
            }();

            waitForPendingLocaleChange = /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!app.i18n.__pendingLocale) {
                          _context4.next = 3;
                          break;
                        }

                        _context4.next = 3;
                        return app.i18n.__pendingLocalePromise;

                      case 3:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));

              return function waitForPendingLocaleChange() {
                return _ref7.apply(this, arguments);
              };
            }();

            getBrowserLocale = function getBrowserLocale() {
              if (process.client && typeof navigator !== 'undefined' && navigator.languages) {
                // Get browser language either from navigator if running on client side, or from the headers
                return matchBrowserLocale(options.normalizedLocales, navigator.languages);
              } else if (req && typeof req.headers['accept-language'] !== 'undefined') {
                return matchBrowserLocale(options.normalizedLocales, parseAcceptLanguage(req.headers['accept-language']));
              } else {
                return undefined;
              }
            };
            /**
             * @param {import('vue-router').Route} route
             * @return {string} Returns the browser locale that was detected or an empty string otherwise.
             */


            doDetectBrowserLanguage = function doDetectBrowserLanguage(route) {
              // Browser detection is ignored if it is a nuxt generate.
              if (process.static && process.server) {
                return '';
              }

              if (options.strategy !== Constants.STRATEGIES.NO_PREFIX) {
                if (redirectOn === Constants.REDIRECT_ON_OPTIONS.ROOT) {
                  if (route.path !== '/') {
                    return '';
                  }
                } else if (redirectOn === Constants.REDIRECT_ON_OPTIONS.NO_PREFIX) {
                  if (!alwaysRedirect && route.path.match(getLocalesRegex(options.localeCodes))) {
                    return '';
                  }
                }
              }

              var matchedLocale;

              if (useCookie && (matchedLocale = app.i18n.getLocaleCookie())) {// Get preferred language from cookie if present and enabled
              } else {
                // Try to get locale from either navigator or header detection
                matchedLocale = getBrowserLocale();
              }

              var finalLocale = matchedLocale || fallbackLocale; // Handle cookie option to prevent multiple redirections

              if (finalLocale && (!useCookie || alwaysRedirect || !app.i18n.getLocaleCookie())) {
                if (finalLocale !== app.i18n.locale) {
                  return finalLocale;
                }
              }

              return '';
            };
            /**
             * Extends the newly created vue-i18n instance with @nuxtjs/i18n properties.
             *
             * @param {import('vue-i18n').IVueI18n} i18n
             */


            extendVueI18nInstance = function extendVueI18nInstance(i18n) {
              i18n.locales = klona(options.locales);
              i18n.localeCodes = klona(options.localeCodes);
              i18n.localeProperties = Vue.observable(klona(options.normalizedLocales.find(function (l) {
                return l.code === i18n.locale;
              }) || {
                code: i18n.locale
              }));
              i18n.defaultLocale = options.defaultLocale;
              i18n.differentDomains = options.differentDomains;
              i18n.onBeforeLanguageSwitch = options.onBeforeLanguageSwitch;
              i18n.onLanguageSwitched = options.onLanguageSwitched;

              i18n.setLocaleCookie = function (locale) {
                return setLocaleCookie(locale, res, {
                  useCookie: useCookie,
                  cookieDomain: cookieDomain,
                  cookieKey: cookieKey,
                  cookieSecure: cookieSecure,
                  cookieCrossOrigin: cookieCrossOrigin
                });
              };

              i18n.getLocaleCookie = function () {
                return getLocaleCookie(req, {
                  useCookie: useCookie,
                  cookieKey: cookieKey,
                  localeCodes: options.localeCodes
                });
              };

              i18n.setLocale = function (locale) {
                return loadAndSetLocale(locale);
              };

              i18n.getBrowserLocale = function () {
                return getBrowserLocale();
              };

              i18n.finalizePendingLocaleChange = finalizePendingLocaleChange;
              i18n.waitForPendingLocaleChange = waitForPendingLocaleChange;
              i18n.__baseUrl = app.i18n.__baseUrl;
              i18n.__pendingLocale = app.i18n.__pendingLocale;
              i18n.__pendingLocalePromise = app.i18n.__pendingLocalePromise;
              i18n.__resolvePendingLocalePromise = app.i18n.__resolvePendingLocalePromise;
            }; // Set instance options


            if (!(typeof options.vueI18n === 'function')) {
              _context5.next = 24;
              break;
            }

            _context5.next = 21;
            return options.vueI18n(context);

          case 21:
            _context5.t0 = _context5.sent;
            _context5.next = 25;
            break;

          case 24:
            _context5.t0 = klona(options.vueI18n);

          case 25:
            vueI18nOptions = _context5.t0;
            vueI18nOptions.componentInstanceCreatedListener = extendVueI18nInstance; // @ts-ignore

            app.i18n = context.i18n = new VueI18n(vueI18nOptions); // Initialize locale and fallbackLocale as vue-i18n defaults those to 'en-US' if falsey

            app.i18n.locale = '';
            app.i18n.fallbackLocale = vueI18nOptions.fallbackLocale || '';

            if (store) {
              // Inject in store.
              store.$i18n = app.i18n;

              if (store.state.localeDomains) {
                _iterator = _createForOfIteratorHelper(options.normalizedLocales.entries());

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _step$value = _slicedToArray(_step.value, 2), index = _step$value[0], locale = _step$value[1];
                    domain = store.state.localeDomains[locale.code];

                    if (domain) {
                      locale.domain = domain;
                      optionsLocale = options.locales[index];

                      if (typeof optionsLocale !== 'string') {
                        optionsLocale.domain = domain;
                      }
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
            }

            extendVueI18nInstance(app.i18n);
            resolveBaseUrlOptions = {
              differentDomains: options.differentDomains,
              normalizedLocales: options.normalizedLocales
            };
            app.i18n.__baseUrl = resolveBaseUrl(options.baseUrl, context, '', resolveBaseUrlOptions);
            app.i18n.__onNavigate = onNavigate;
            Vue.prototype.$nuxtI18nHead = nuxtI18nHead;
            /** @type {string | undefined} */

            finalLocale = options.detectBrowserLanguage ? doDetectBrowserLanguage(route) : '';

            if (!finalLocale) {
              if (app.i18n.differentDomains) {
                domainLocale = getLocaleDomain(options.normalizedLocales, req);
                finalLocale = domainLocale;
              } else if (options.strategy !== Constants.STRATEGIES.NO_PREFIX) {
                routeLocale = getLocaleFromRoute(route);
                finalLocale = routeLocale;
              }
            }

            if (!finalLocale && useCookie) {
              finalLocale = app.i18n.getLocaleCookie();
            }

            if (!finalLocale) {
              finalLocale = app.i18n.defaultLocale || '';
            }

            _context5.next = 42;
            return loadAndSetLocale(finalLocale, {
              initialSetup: true
            });

          case 42:
            if (!(process.client && process.static && nuxtOptions.isUniversalMode)) {
              _context5.next = 50;
              break;
            }

            _context5.next = 45;
            return onNavigate(context.route);

          case 45:
            _yield$onNavigate = _context5.sent;
            _yield$onNavigate2 = _slicedToArray(_yield$onNavigate, 2);
            _ = _yield$onNavigate2[0];
            redirectTo = _yield$onNavigate2[1];

            if (redirectTo) {
              location.assign(joinURL(context.base, redirectTo));
            }

          case 50:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();